import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'GET_DOCUMENTS_LIST';

interface DocumentPreviewMap {
  files: string[];
  firstFile: string;
}

const useDocumentsUrls = (urls: string[]) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, ...urls],
    () =>
      api.get(API_URL.DOCUMENTS_FILES, {
        params: {
          'document-ids': urls,
        },
      }),
    {
      enabled: !!urls.length,
    }
  );

  const formattedList = useMemo(() => {
    const list = data?.data;
    return list?.map((item) => ({
      id: item.document_id,
      urls:
        item?.files?.reduce((result: string[], file) => {
          if (file.s3_url) {
            return [...result, file.s3_url];
          }
          return result;
        }, []) || [],
    }));
  }, [data?.data]);

  const valuesMap = useMemo(() => {
    return formattedList?.reduce((result: Record<string, DocumentPreviewMap>, item) => {
      if (item.id && item.urls && !!item.urls.length) {
        return {
          ...result,
          [`${item.id}`]: {
            files: item.urls,
            firstFile: item.urls[0],
          },
        };
      }
      return result;
    }, {});
  }, [formattedList]);

  return {
    valuesMap,
    isLoading,
    data: formattedList,
  };
};

export default useDocumentsUrls;
